import { render, staticRenderFns } from "./tourParameterConfig.vue?vue&type=template&id=a8147f16&scoped=true&"
import script from "./tourParameterConfig.vue?vue&type=script&lang=js&"
export * from "./tourParameterConfig.vue?vue&type=script&lang=js&"
import style0 from "./tourParameterConfig.vue?vue&type=style&index=0&id=a8147f16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8147f16",
  null
  
)

export default component.exports